import axios from '../utils/axios';

export default function addIntegrations(adminId, integration, data) {
    return (
        axios.post(`/admin/${adminId}/ats-integrations/${integration}/recruiters`,  data )
    )
}
